export const PageDataState = {
    Searchs: {
        types: {
            type: 'select',
            id: 'types',
            label: 'ประเภท',
            value: '',
            placeholder: 'ประเภท',
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกษา',
        }, 
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            placeholder: 'อุตสาหกรรม',
        },                
        name: {
            type: 'text',
            id: 'name',
            label: 'หัวข้อ',
            value: '',
            placeholder: 'หัวข้อ',
        },
        start_publicize_date: {
            type: 'text',
            id: 'start_publicize_date',
            label: 'เริ่มต้น',
            value: '',
            placeholder: 'เริ่มต้น',
        },
        end_publicize_date: {
            type: 'text',
            id: 'end_publicize_date',
            label: 'สิ้นสุด',
            value: '',
            placeholder: 'สิ้นสุด',
        },        
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            placeholder: 'สถานะ',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        types_by: {
            type: 'select',
            id: 'types_by',
            label: 'ประกาศโดย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        types: {
            type: 'select',
            id: 'types',
            label: 'ประเภท',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        user_id: {
            type: 'select',
            id: 'user_id',
            label: 'ผู้ใช้งาน',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        }, 
        target_industries_id: {
            type: 'select',
            id: 'target_industries_id',
            label: 'อุตสาหกรรม',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        course_eb_01_id: {
            type: 'select',
            id: 'course_eb_01_id',
            label: 'หลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },        
        name: {
            type: 'text',
            id: 'name',
            label: 'หัวข้อ',
            value: '',
            placeholder: 'หัวข้อ',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }            
        },  
        detail: {
            type: 'textarea',
            rows: 8,
            id: 'detail',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        contact: {
            type: 'textarea',
            rows: 5,
            id: 'contact',
            label: 'ข้อมูลการติดต่อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },  
        url_link: {
            type: 'text',
            id: 'url_link',
            label: 'ลิงค์',
            value: '',
            placeholder: 'ลิงค์',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }            
        },                                     
        photo: {
            type: 'file',
            id: 'photo',
            label: 'รูปภาพ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        files: {
            type: 'file',
            id: 'files',
            label: 'ไฟล์แนบ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            },
            error: { status: null, msg: '' }
        },        
        publicize_date: {
            type: 'text',
            id: 'publicize_date',
            label: 'วันที่ประกาศ',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        expired_date: {
            type: 'text',
            id: 'expired_date',
            label: 'วันที่หมดอายุ',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },        
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }        
    },
    InputGroup: {}
}    